import script from "./OperationLogDialogBox.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationLogDialogBox.vue?vue&type=script&setup=true&lang=js"

import "./OperationLogDialogBox.vue?vue&type=style&index=0&id=64477ef2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64477ef2"]])

export default __exports__